import SectionWrapper from '@/components/Landing/SectionWrapper'
import { useState } from 'react'

const CARD_WIDTH = 254
const CARD_HEIGHT = 240
const CARD_PADDING_X = 24
const CARD_PADDING_Y = 20
const CARD_GAP = 28
const ROWS_TO_SHOW = 3

const data = [
  {
    category: 'Productivity',
    title: 'Analyze & Create PDFs',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872412/Analyze_Create_PDFs_mgvegs.jpg',
  },
  {
    category: 'Social',
    title: 'Twitter Search',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Twitter_Search_eaxmzk.jpg',
  },
  {
    category: 'Social',
    title: 'Reddit Search',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Reddit_Search_t4havq.jpg',
  },
  {
    category: 'Design',
    title: 'Graphic Designer',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872417/Graphic_Designer_cuvbpx.jpg',
  },
  {
    category: 'Research',
    title: 'Facebook Ads Scraper',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872416/Facebook_Ads_Scraper_ykuu9k.jpg',
  },
  {
    category: 'Media',
    title: 'YouTube Transcriber',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872425/YouTube_Transcriber_pibzcx.jpg',
  },
  {
    category: 'Design',
    title: 'Background Remover',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872413/Background_Remover_jddzi4.jpg',
  },
  {
    category: 'Development',
    title: 'HTML Formatter',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872417/HTML_Formatter_xtlsfb.jpg',
  },
  {
    category: 'Research',
    title: 'Deep Research',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872416/Deep_Research_bfrkcf.jpg',
  },
  {
    category: 'AI',
    title: 'Generate AI images',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872417/Generate_AI_images_ht4zay.jpg',
  },
  {
    category: 'Productivity',
    title: 'Analyze & Create Spreadsheets',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872412/Analyze_Create_Spreadsheets_sblnzg.jpg',
  },
  {
    category: 'Web',
    title: 'Search the web',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872416/Do_web_searches_pbcg11.jpg',
  },
  {
    category: 'Content',
    title: 'Write Articles & Documents',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Write_Articles_Documents_koz0j1.jpg',
  },
  {
    category: 'Web',
    title: 'Crawl and analyze web pages',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872414/Crawl_and_analyze_web_pages_e2ghih.jpg',
  },
  {
    category: 'AI',
    title: 'Analyze images with AI',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872412/Analyze_images_with_AI_efweq1.jpg',
  },
  {
    category: 'AI',
    title: 'Analyze content with AI',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872414/Analyze_content_with_AI_eudia9.jpg',
  },
  {
    category: 'Research',
    title: 'Shopify Reviews Research',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Shopify_Reviews_Research_icix6i.jpg',
    comingSoon: true,
  },
  {
    category: 'Research',
    title: 'SEO Research',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/SEO_Research_jbh5jg.jpg',
    comingSoon: true,
  },
  {
    category: 'Social',
    title: 'Post to LinkedIn',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872423/Post_to_LinkedIn_mczcuo.jpg',
    comingSoon: true,
  },
  {
    category: 'Social',
    title: 'Post to Twitter',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Post_to_Twitter_xn7gif.jpg',
    comingSoon: true,
  },
  {
    category: 'Communication',
    title: 'Send messages on Slack',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Send_messages_on_Slack_ysc6m3.jpg',
    comingSoon: true,
  },
  {
    category: 'Productivity',
    title: 'Write to Notion',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872425/Write_to_Notion_p8jo4c.jpg',
    comingSoon: true,
  },
  {
    category: 'Communication',
    title: 'Send and analyze emails',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872424/Send_and_analyze_emails_t7lilv.jpg',
    comingSoon: true,
  },
  {
    category: 'Design',
    title: 'Generate template images',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872417/Generate_template_images_ole8bj.jpg',
    comingSoon: true,
  },
  {
    category: 'Media',
    title: 'Generate AI videos',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872417/Generate_AI_videos_tp4im3.jpg',
    comingSoon: true,
  },
  {
    category: 'Media',
    title: 'Edit videos',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1744768717/s_16_o3dmuy.png',
    comingSoon: true,
  },
  {
    category: 'Research',
    title: 'AppStore Reviews Research',
    src: 'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1748872413/AppStore_Reviews_Research_o0ypri.jpg',
    comingSoon: true,
  },
]

function SuperpowersCard({
  title,
  src,
  comingSoon,
}: {
  title: string
  src: string
  comingSoon?: boolean
}) {
  return (
    <div
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        padding: `${CARD_PADDING_Y}px ${CARD_PADDING_X}px`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: CARD_GAP,
        borderRadius: 24,
        background: `url(${src}) center center / cover no-repeat`,
        boxShadow: '0 4px 24px 0 rgba(0,0,0,0.08)',
        position: 'relative',
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      {/* Overlay for readability */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 66%, rgba(0,0,0,0.32) 100%)',
          borderRadius: 24,
          zIndex: 1,
        }}
      />
      {comingSoon && (
        <div
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            display: 'flex',
            padding: '10px 16px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 10,
            borderRadius: 32,
            border: '1px solid rgba(255, 255, 255, 0.30)',
            background: 'rgba(0, 0, 0, 0.12)',
            backdropFilter: 'blur(5px)',
            color: '#fff',
            fontSize: 20,
            fontWeight: 400,
            fontFamily: 'inherit',
            zIndex: 2,
            lineHeight: 1.2,
            boxSizing: 'border-box',
          }}
        >
          Coming soon
        </div>
      )}
      <div style={{ position: 'relative', zIndex: 2, width: '100%' }}>
        <div style={{ fontWeight: 600, fontSize: 20, color: '#fff', marginBottom: 0 }}>{title}</div>
      </div>
    </div>
  )
}

function ShowMoreButton({ showAll, onClick }: { showAll: boolean; onClick: () => void }) {
  return (
    <div className="mt-8 flex justify-center">
      <button
        className="rounded-lg border border-[#DCDCDC] bg-white px-6 py-2 text-black transition-colors hover:bg-[#DCDCDC]"
        style={{ fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '0.01em' }}
        onClick={onClick}
      >
        {showAll ? 'Show Less' : 'Show More'}
      </button>
    </div>
  )
}

export default function SuperpowersGrid() {
  const [expanded, setExpanded] = useState(false)
  const [cardsPerRow, setCardsPerRow] = useState(5)

  // Calculate how many cards to show based on rows
  const calculateCardsToShow = () => {
    if (expanded) return data.length
    return cardsPerRow * ROWS_TO_SHOW
  }

  // Update cardsPerRow when container width changes
  const updateCardsPerRow = (containerWidth: number) => {
    const newCardsPerRow = Math.floor((containerWidth + CARD_GAP) / (CARD_WIDTH + CARD_GAP))
    setCardsPerRow(Math.max(1, newCardsPerRow))
  }

  return (
    <SectionWrapper
      className="w-full overflow-clip rounded-2xl bg-center px-1 py-16"
      title={<>Power up your workflows</>}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fit, minmax(${CARD_WIDTH}px, 0fr))`,
          gap: 24,
          justifyContent: 'center',
          width: '100%',
          overflowX: 'auto',
          marginTop: 36,
        }}
        ref={(el) => {
          if (el) {
            const observer = new ResizeObserver((entries) => {
              for (const entry of entries) {
                updateCardsPerRow(entry.contentRect.width)
              }
            })
            observer.observe(el)
            return () => observer.disconnect()
          }
        }}
      >
        {data.slice(0, calculateCardsToShow()).map((card, idx) => (
          <SuperpowersCard key={card.title + idx} {...card} />
        ))}
      </div>
      {data.length > cardsPerRow * ROWS_TO_SHOW && (
        <ShowMoreButton showAll={expanded} onClick={() => setExpanded((v) => !v)} />
      )}
    </SectionWrapper>
  )
}
